/*
  SylverCar — Bilan confort & équipement : moteur du quiz.

  UN FICHIER, DES DONNÉES. Les textes, les écrans et la logique de saut sont
  ci-dessous ; les listes de produits viennent de l'administration (objet
  quiz_liste, publiées par snippets/bilan-quiz.liquid). Aucune application
  tierce, aucune bibliothèque.

  PRINCIPES
  - Navigation PAR CHEMIN. Les réponses sont rangées par écran, mais seules
    celles des écrans du chemin ACTUEL comptent (voir `A()`). Revenir en arrière
    et changer une réponse recalcule donc tout ce qui suit, sans état périmé.
  - Rien ne part vers Omnisend avant la saisie de l'e-mail ; avant, les
    réponses ne quittent pas le navigateur (sessionStorage).
  - Aucun e-mail, aucune donnée personnelle dans l'URL, ni dans un événement.
  - Le quiz ne bloque jamais le visiteur : si l'envoi échoue, la page de
    résultat s'affiche quand même et l'envoi est retenté plus tard.
  - Les événements de suivi sont émis par Shopify.analytics.publish (qui
    respecte le consentement) ; rien n'est branché à GA4/Meta dans cette
    version : on pourra le faire plus tard sans toucher au quiz.
*/
(function () {
  'use strict';

  var racine = document.querySelector('[data-bq]');
  if (!racine) return;

  var DATA = {};
  try { DATA = JSON.parse(document.getElementById('bq-data').textContent); } catch (e) { DATA = { listes: {}, images: {} }; }
  var LISTES = DATA.listes || {};
  var IMAGES = DATA.images || {};

  var ecran = racine.querySelector('[data-bq-ecran]');
  var contenu = racine.querySelector('[data-bq-contenu]');
  var visuel = racine.querySelector('[data-bq-visuel]');
  var btnPrecedent = racine.querySelector('[data-bq-precedent]');
  var lienRetour = racine.querySelector('[data-bq-retour-site]');
  var barre = racine.querySelector('[data-bq-barre]');
  var pctTexte = racine.querySelector('[data-bq-pct]');

  var CLE_SESSION = 'sc_bilan_session';
  var CLE_ID = 'sc_bilan_id';
  var CLE_FILE = 'sc_bilan_file';

  var BRANCHES = ['confort', 'housses', 'organisation', 'ambiance'];
  var SOUS = ['rangement', 'telephone', 'proprete'];
  var NOM_BRANCHE = {
    confort: 'Mon confort de conduite', housses: 'Mes sièges',
    organisation: 'Mon habitacle', ambiance: "L'ambiance"
  };
  var SOUS_TEXTE = {
    confort: 'Dos, assise, nuque, position', housses: 'Protéger, relooker, adapter à la saison',
    organisation: 'Rangement, téléphone, propreté', ambiance: 'Parfum, décoration'
  };

  /* ------------------------------------------------------------------ */
  /* Utilitaires                                                         */
  /* ------------------------------------------------------------------ */
  function echapper(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function lire(cle, stock) {
    try { return JSON.parse((stock || sessionStorage).getItem(cle)); } catch (e) { return null; }
  }
  function ecrire(cle, val, stock) {
    try { (stock || sessionStorage).setItem(cle, JSON.stringify(val)); } catch (e) { /* stockage indisponible : le quiz fonctionne sans */ }
  }
  function effacer(cle, stock) {
    try { (stock || sessionStorage).removeItem(cle); } catch (e) { }
  }
  function inclus(tab, v) { return !!tab && tab.indexOf(v) >= 0; }
  function unique(tab) { return tab.filter(function (v, i) { return tab.indexOf(v) === i; }); }
  function aujourdhui() { return new Date().toISOString().slice(0, 10); }

  var ICONE_COCHE = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 7.5 5.5 10.5 11.5 3.5"/></svg>';

  /* ------------------------------------------------------------------ */
  /* État                                                                */
  /* ------------------------------------------------------------------ */
  var S = {
    ans: {},        // réponses, par identifiant d'écran
    pile: [],       // écrans déjà vus (pour « Précédent »)
    cur: 'accueil', // écran affiché
    preset: [],     // écrans pré-répondus par un lien profond
    force: null,    // branche imposée (lien profond, exploration)
    sauteS1: false, // exploration : on ne repose ni S1 ni l'e-mail
    src: '',        // paramètre « source » de l'URL d'entrée
    profond: false, // arrivé par un lien profond
    run: 1          // numéro du bilan sur cet appareil
  };

  function sauver() {
    ecrire(CLE_SESSION, { ans: S.ans, pile: S.pile, cur: S.cur, preset: S.preset, force: S.force, sauteS1: S.sauteS1, src: S.src, profond: S.profond, run: S.run });
  }

  /* Un écran compte dans le chemin s'il a été traversé ou s'il est affiché. */
  function enChemin(id) {
    return S.cur === id || S.pile.indexOf(id) >= 0 || S.preset.indexOf(id) >= 0;
  }
  function A(id) { return enChemin(id) ? S.ans[id] : undefined; }

  /* ------------------------------------------------------------------ */
  /* Identité du visiteur (section 16)                                   */
  /* ------------------------------------------------------------------ */
  function parametreUrl(nom) {
    try { return new URLSearchParams(location.search).get(nom); } catch (e) { return null; }
  }
  function lienEmail() {
    if (parametreUrl('omnisendContactID')) return true;
    return /(?:^|;\s*)omnisendContactID=/.test(document.cookie || '');
  }
  function identite() {
    var st = lire(CLE_ID, localStorage) || {};
    if (DATA.client) return { email: DATA.client, via: 'customer', optin: st.optin || null, nb: st.nb || 0, premier: st.premier || null };
    if (st.email) return { email: st.email, via: 'browser', optin: st.optin || null, nb: st.nb || 0, premier: st.premier || null };
    if (lienEmail()) return { email: null, via: 'email_link', optin: null, nb: st.nb || 0, premier: st.premier || null };
    return null;
  }
  function oublierIdentite() { effacer(CLE_ID, localStorage); }

  /* ------------------------------------------------------------------ */
  /* Suivi : événements du brief, sans aucune donnée personnelle         */
  /* ------------------------------------------------------------------ */
  function suivre(nom, donnees) {
    try {
      var charge = donnees || {};
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(nom, charge);
      }
    } catch (e) { /* le suivi ne doit jamais gêner le visiteur */ }
  }

  /* ------------------------------------------------------------------ */
  /* Logique : branche, zone, sortie, listes                             */
  /* ------------------------------------------------------------------ */
  /* Branche de départ : lien profond, orientation, arbitrage ou pivot. */
  function brancheBase() {
    if (S.force) return S.force;
    var o = A('orient');
    if (enChemin('orient') && o && o.length === 1) return o[0];
    var arb = A('arb');
    if (enChemin('orient') && o && o.length > 1 && arb && inclus(BRANCHES, arb)) return arb;
    var p = A('pivot');
    if (p && p !== 'inconnu') return p;
    return null;
  }
  /* Branche principale. Cas « déjà bien équipé » : la branche choisie à S1
     devient la branche principale (section 5). */
  function branche() {
    if (!S.force && enChemin('equipe') && A('S1') && A('S1').length) return A('S1')[0];
    return brancheBase();
  }
  function sousParcours() {
    var arb = A('arb');
    if (arb && inclus(SOUS, arb)) return arb;
    var o1 = A('O1');
    return o1 && o1.length ? o1[0] : null;
  }

  function zoneInitiale() {
    var c = A('C1');
    return c === 'partout' ? A('C1b') : c;
  }
  function zone() {
    if (A('couvert') === 'completer' && A('couvert2')) return A('couvert2');
    return zoneInitiale();
  }
  function zonesCouvertes() {
    var c = A('C6') || [], z = [];
    if (inclus(c, 'lombaire')) z.push('dos');
    if (inclus(c, 'assise')) { z.push('assise'); z.push('position'); }
    if (inclus(c, 'appui_tete')) z.push('nuque');
    return z;
  }
  function toutesPossedees() {
    var c = A('C6') || [];
    return inclus(c, 'lombaire') && inclus(c, 'assise') && inclus(c, 'appui_tete');
  }
  function zonesProposables() {
    var z = zone(), cov = zonesCouvertes();
    return ['dos', 'assise', 'nuque'].filter(function (x) { return x !== z && cov.indexOf(x) < 0; });
  }
  function zonesNonCouvertes() {
    var cov = zonesCouvertes();
    return ['dos', 'assise', 'nuque'].filter(function (x) { return cov.indexOf(x) < 0; });
  }
  function c7ou70() {
    return (zone() === 'position' || !zonesProposables().length) ? 't70' : 'C7';
  }

  function sortie() {
    var b = branche();
    if (b === 'confort') {
      var z1 = zone(), z2 = A('C7');
      if (z2 === 'non') z2 = null;
      if (z1 === 'position') return 'confort_rehaussement';
      if (z2 && z2 !== z1) {
        var k = [z1, z2].sort().join('+');
        if (k === 'dos+nuque') return 'confort_dos_nuque';
        if (k === 'assise+nuque') return 'confort_assise_nuque';
        if (k === 'assise+dos') return 'confort_dos_assise';
      }
      return 'confort_' + z1;
    }
    if (b === 'housses') {
      var h1 = A('H1');
      if (h1 === 'saison') return A('H1b') === 'hiver' ? 'housses_saison_hiver' : 'housses_saison_ete';
      return 'housses_' + h1;
    }
    if (b === 'organisation') return 'organisation_' + sousParcours();
    if (b === 'ambiance') {
      var a1 = A('A1');
      return a1 === 'parfum' ? 'ambiance_parfum' : a1 === 'deco' ? 'ambiance_decoration' : 'ambiance_parfum_decoration';
    }
    return '';
  }

  function listesTelephone() {
    var p2 = A('P2'), p3 = A('P3');
    if (p3 === 'oui') return ['telephone_induction'];
    switch (p2) {
      case 'aeration': return ['telephone_tableau_grille', 'telephone_magnetique'];
      case 'tableau_de_bord': return ['telephone_tableau_grille', 'telephone_magnetique', 'telephone_ventouse', 'telephone_gravite_bras'];
      case 'pare_brise': return ['telephone_ventouse', 'telephone_gravite_bras', 'telephone_retroviseur'];
      case 'console': return ['telephone_magnetique', 'telephone_tableau_grille'];
      default: return ['telephone_induction', 'telephone_magnetique', 'telephone_ventouse', 'telephone_gravite_bras', 'telephone_retroviseur', 'telephone_tableau_grille'];
    }
  }
  function listesParfum() {
    var a2 = A('A2');
    if (a2 === 'diffuseur') return ['parfum_diffuseur'];
    if (a2 === 'desodorisant') return ['parfum_desodorisant'];
    return ['parfum_diffuseur', 'parfum_desodorisant'];
  }
  function listesDeco() {
    var a = A('A2b');
    if (a === 'figurines') return ['deco_figurines'];
    if (a === 'stickers') return ['deco_stickers'];
    return ['deco_figurines:4', 'deco_stickers:4']; // « Je ne sais pas encore » : 4 + 4
  }
  /* Codes de liste, avec une limite éventuelle sous la forme code:N. */
  function listes() {
    var s = sortie();
    switch (s) {
      case 'confort_dos_nuque': return ['confort_dos', 'confort_nuque'];
      case 'confort_assise_nuque': return ['confort_assise', 'confort_nuque'];
      case 'confort_dos_assise': return ['confort_dos', 'confort_assise'];
      case 'organisation_rangement': return ['rangement_' + A('O2')];
      case 'organisation_telephone': return listesTelephone();
      case 'organisation_proprete': return ['proprete_' + A('N2')];
      case 'ambiance_parfum': return listesParfum();
      case 'ambiance_decoration': return listesDeco();
      case 'ambiance_parfum_decoration': return listesParfum().concat(listesDeco());
      default: return [s];
    }
  }
  /* Nombre réel de produits distincts affichés par la sortie. */
  function nombreProduits() {
    var vus = {};
    listes().forEach(function (item) {
      var p = item.split(':'), tab = LISTES[p[0]] || [];
      if (p[1]) tab = tab.slice(0, parseInt(p[1], 10) || tab.length);
      tab.forEach(function (h) { vus[h] = 1; });
    });
    // La page de résultat affiche 24 produits au plus : le compte annoncé reste vrai.
    return Math.min(24, Object.keys(vus).length);
  }

  var PHRASES = {
    confort_dos: 'mieux soutenir votre dos au volant',
    confort_assise: 'améliorer le confort de votre assise',
    confort_nuque: 'mieux soutenir votre nuque et votre tête',
    confort_rehaussement: 'rehausser votre position de conduite',
    confort_dos_nuque: 'mieux soutenir votre dos et votre nuque',
    confort_assise_nuque: 'améliorer votre assise et soutenir votre nuque',
    confort_dos_assise: 'mieux soutenir votre dos et améliorer votre assise',
    housses_confort: 'rendre vos sièges plus confortables',
    housses_proteger: 'protéger vos sièges',
    housses_relooker: 'donner un nouveau style à vos sièges',
    housses_saison_ete: 'garder vos sièges frais en été',
    housses_saison_hiver: 'rendre vos sièges plus doux en hiver',
    housses_sport: 'donner un style sportif à vos sièges',
    organisation_telephone: 'bien installer votre téléphone',
    ambiance_parfum: 'parfumer votre voiture',
    ambiance_decoration: 'décorer votre voiture',
    ambiance_parfum_decoration: 'parfumer et décorer votre voiture'
  };
  var PHRASE_RANGEMENT = {
    dos_sieges: 'mieux ranger vos affaires au dos des sièges avant',
    entre_sieges: 'mieux ranger vos affaires entre les sièges',
    console: 'mieux ranger vos affaires sur la console centrale',
    coffre: 'mieux ranger vos affaires dans le coffre'
  };
  var PHRASE_PROPRETE = {
    poussiere: 'dépoussiérer votre habitacle',
    dechets: 'ranger vos déchets',
    vitres: 'entretenir vos vitres et votre tableau de bord',
    carrosserie: 'entretenir la carrosserie'
  };
  function phrase() {
    var s = sortie(), p;
    if (s === 'organisation_rangement') p = PHRASE_RANGEMENT[A('O2')];
    else if (s === 'organisation_proprete') p = PHRASE_PROPRETE[A('N2')];
    else p = PHRASES[s];
    p = p || 'trouver les bons accessoires';
    if (/^confort_(dos|assise|nuque|rehaussement)/.test(s) && (A('C2') === 'plus_1h30' || A('C2') === 'travail')) p += ' pendant vos longs trajets';
    return p;
  }
  function pluriel(n, un, plusieurs) { return n + ' ' + (n > 1 ? plusieurs : un); }

  /* Autres sujets cochés (à l'orientation ou à l'arbitrage) : présélectionnés à S1. */
  /* Sujets d'Organisation cochés à O1 en plus de celui traité (Rangement, Téléphone, Propreté). */
  function sousParcoursEnAttente() {
    if (brancheBase() !== 'organisation') return [];
    var o1 = A('O1') || [], choisi = sousParcours();
    return o1.filter(function (x) { return x !== choisi; });
  }
  function enAttente() {
    var b = brancheBase(), o = A('orient'), liste = [];
    if (enChemin('orient') && o && o.length > 1) liste = o.filter(function (x) { return x !== b; });
    return sousParcoursEnAttente().map(function (k) { return 'sp_' + k; }).concat(liste);
  }
  function secondaires() {
    var b = brancheBase(), s1 = A('S1') || [];
    if (enChemin('equipe')) return s1.slice(1);
    return s1.filter(function (x) { return x !== 'non' && x !== b; });
  }

  /* ------------------------------------------------------------------ */
  /* Écrans : définition, image, progression                             */
  /* ------------------------------------------------------------------ */
  var IMG = {
    accueil: 'P01', t1: 'P02', pivot: 'P03', orient: 'P04', arb: 'P03',
    C1: 'P06', C1b: 'P06', C2: 'P07', C3: 'P08', C4: 'P09', C5: 'P10', C6: 'P11', C7: 'P12',
    couvert: 'P11', couvert2: 'P11', equipe: 'P11',
    H1: 'P14', H1b: 'P15', H5: 'P19', H6: 'P20',
    O1: 'P23', O2: 'P24', O4: 'P26', P2: 'P27', P3: 'P28', N2: 'P30',
    A1: 'P33', A2: 'P34', A2b: 'P35',
    t70: 'P36', S1: 'P37', S2: 'P38', S3: 'P39', S4: 'P40', S5: 'P40'
  };
  var IMG_T2 = { confort: 'P05', housses: 'P13', organisation: 'P22', ambiance: 'P32' };
  var PCT = {
    accueil: 0, t1: 5, pivot: 10, orient: 12, arb: 15, t2: 20,
    C1: 24, C1b: 27, C2: 33, C3: 40, C4: 47, C5: 54, C6: 60, couvert: 63, couvert2: 65, equipe: 66, C7: 68,
    H1: 28, H1b: 36, H5: 48, H6: 60,
    O1: 28, O2: 40, O4: 55, P2: 40, P3: 55, N2: 45,
    A1: 30, A2: 45, A2b: 55,
    t70: 70, S1: 75, S2: 80, S3: 83, S4: 85, S5: 90, S6: 100
  };
  function pourcent() {
    var id = S.cur;
    if (id === 'arb' && enChemin('O1') && !enChemin('orient')) return 33;
    if (id === 'A2b' && A('A1') === 'les_deux') return 58;
    return PCT[id] != null ? PCT[id] : 0;
  }

  var T2 = {
    confort: "Pour vous proposer des produits réellement compatibles, parlons de vos trajets et de votre siège.",
    housses: "Quelques précisions pour choisir des housses qui s'installent vraiment sur vos sièges.",
    organisation: "Dites-nous ce qui vous gêne : nous vous montrons ce qui s'installe facilement dans votre habitacle.",
    ambiance: "Quelques choix pour une voiture qui vous ressemble."
  };
  var COULEURS = [
    { v: 'noir', t: 'Noir', c: '#1a1d1f' }, { v: 'gris', t: 'Gris', c: '#8a9096' },
    { v: 'beige', t: 'Beige', c: '#d9c9a9' }, { v: 'marron', t: 'Marron', c: '#6a4a33' },
    { v: 'autre', t: 'Autre ou je ne sais pas', c: '#ffffff', inconnu: true }
  ];

  /* Définition d'un écran. `type` : accueil | transition | choix | multi | visuel | couleur | info | apercu | email | optin | charge */
  function def(id) {
    var b = branche();
    switch (id) {
      case 'accueil': return { type: 'accueil' };
      case 't1': return { type: 'transition', chap: 'Chapitre 1 · Votre priorité', texte: "Commençons par l'essentiel : qu'est-ce qui compte le plus pour vous ?" };
      case 'pivot': return {
        type: 'choix', titre: 'Que souhaitez-vous améliorer en priorité dans votre voiture ?',
        aide: 'Choisissez le sujet le plus important. Vous pourrez en ajouter un second à la fin.',
        options: BRANCHES.map(function (k) { return { v: k, t: NOM_BRANCHE[k], s: SOUS_TEXTE[k] }; })
          .concat([{ v: 'inconnu', t: 'Je ne sais pas encore', s: 'Nous vous aidons à choisir' }])
      };
      case 'orient': return {
        type: 'multi', titre: "Qu'est-ce qui vous dérange le plus aujourd'hui ?", aide: 'Plusieurs réponses possibles.',
        options: [
          { v: 'confort', t: 'Après un moment, je suis mal installé' },
          { v: 'housses', t: 'Mes sièges font vieux ou abîmés' },
          { v: 'organisation', t: 'Tout traîne, je ne retrouve rien' },
          { v: 'ambiance', t: 'Ma voiture manque de personnalité' }]
      };
      case 'arb': {
        var dansO1 = enChemin('O1') && !enChemin('orient');
        var coches = dansO1 ? (A('O1') || []) : (A('orient') || []);
        var nomsSous = { rangement: 'Des objets qui traînent partout', telephone: "Mon téléphone n'est pas bien placé", proprete: 'La saleté et les déchets' };
        return {
          type: 'choix', titre: 'Par lequel souhaitez-vous commencer ?', aide: 'Nous traiterons les autres ensuite, à la fin du bilan.',
          options: coches.map(function (k) { return { v: k, t: dansO1 ? nomsSous[k] : NOM_BRANCHE[k] }; })
        };
      }
      case 't2': return { type: 'transition', chap: 'Chapitre 2 · Votre situation', texte: T2[b] || '', imgId: IMG_T2[b] };
      /* --- Confort --- */
      case 'C1': return {
        type: 'choix', titre: 'Quelle zone souhaitez-vous améliorer en priorité ?', aide: 'Une seule zone pour commencer.',
        options: [
          { v: 'dos', t: 'Le bas du dos', s: 'Soutien lombaire' },
          { v: 'assise', t: "L'assise", s: 'Fessiers, coccyx, pression sur le siège' },
          { v: 'nuque', t: 'La nuque et la tête', s: 'Appui-tête, nuque' },
          { v: 'position', t: 'Ma position', s: 'Je suis trop bas ou je vois mal la route' },
          { v: 'partout', t: 'Un peu partout', s: 'Je suis fatigué après un long trajet' }]
      };
      case 'C1b': return {
        type: 'choix', titre: 'Où cela se ressent-il d\'abord ?', aide: '',
        options: [{ v: 'dos', t: 'Le dos' }, { v: 'assise', t: "L'assise" }, { v: 'nuque', t: 'La nuque' }]
      };
      case 'C2': return {
        type: 'choix', titre: 'Quels trajets faites-vous le plus souvent ?', aide: 'Cela nous aide à choisir le bon niveau de confort pour la durée.',
        options: [
          { v: 'moins_30min', t: 'Moins de 30 minutes' }, { v: '30min_1h30', t: 'Entre 30 minutes et 1h30' },
          { v: 'plus_1h30', t: "Plus d'1h30" }, { v: 'travail', t: 'Je conduis pour mon travail' }]
      };
      case 'C3': return {
        type: 'choix', titre: 'Quel type de soutien préférez-vous ?', aide: 'Si vous hésitez, choisissez « Équilibré ».',
        options: [
          { v: 'ferme', t: 'Ferme', s: 'Un maintien net et structuré' },
          { v: 'equilibre', t: 'Équilibré', s: 'Un compromis entre fermeté et douceur' },
          { v: 'moelleux', t: 'Moelleux', s: 'Une sensation enveloppante' }]
      };
      case 'C4': return {
        type: 'choix', titre: "Qu'est-ce qui compte le plus pour vous ?", aide: 'Une seule réponse.',
        options: [
          { v: 'respirabilite', t: 'Respirabilité', s: 'Surtout en été' }, { v: 'discretion', t: 'Discrétion', s: 'Fin et peu visible' },
          { v: 'style', t: 'Style', s: 'Cuir, finitions soignées' }, { v: 'polyvalence', t: 'Polyvalence', s: 'Voiture, bureau, maison' }]
      };
      case 'C5': return {
        type: 'choix', titre: 'Comment est votre siège ?', aide: 'Si vous ne savez pas, pas de souci : nous vous indiquerons les points à vérifier.',
        options: [
          { v: 'standard', t: 'Siège standard' }, { v: 'sport', t: 'Siège sport (baquet)' },
          { v: 'lombaire_integre', t: 'Soutien lombaire réglable intégré' }, { v: 'inconnu', t: 'Je ne sais pas' }]
      };
      case 'C6': return {
        type: 'multi', titre: 'Avez-vous déjà un accessoire de confort ?', aide: 'Cochez ceux que vous utilisez déjà : nous éviterons les doublons.',
        options: [
          { v: 'lombaire', t: 'Un coussin lombaire' }, { v: 'assise', t: "Un coussin d'assise" },
          { v: 'appui_tete', t: 'Un appui-tête ou coussin de nuque' }, { v: 'aucun', t: 'Aucun', excl: true }]
      };
      case 'couvert': return {
        type: 'choix', titre: 'Vous avez déjà un accessoire pour cette zone', aide: 'Que préférez-vous ?',
        options: [{ v: 'remplacer', t: 'Je souhaite le remplacer' }, { v: 'completer', t: 'Je préfère compléter une autre zone' }]
      };
      case 'couvert2': {
        var noms = { dos: 'Le dos', assise: "L'assise", nuque: 'La nuque' };
        return {
          type: 'choix', titre: 'Quelle zone souhaitez-vous améliorer à la place ?', aide: '',
          options: zonesNonCouvertes().map(function (z) { return { v: z, t: noms[z] }; })
        };
      }
      case 'equipe': return {
        type: 'info', titre: 'Vous êtes déjà bien équipé',
        texte: 'Vous avez déjà un accessoire pour chaque zone. Découvrons ce qui pourrait compléter votre installation.'
      };
      case 'C7': {
        var nomsZ = { dos: 'Le dos', assise: "L'assise", nuque: 'La nuque' };
        return {
          type: 'choix', titre: 'Souhaitez-vous aussi améliorer une autre zone ?', aide: 'Facultatif. Nous la ferons figurer dans votre sélection.',
          options: zonesProposables().map(function (z) { return { v: z, t: nomsZ[z] }; }).concat([{ v: 'non', t: 'Non, uniquement cette zone' }])
        };
      }
      /* --- Housses --- */
      case 'H1': return {
        type: 'choix', titre: 'Quel est votre objectif principal ?', aide: 'Une seule réponse.',
        options: [
          { v: 'confort', t: 'Confort', s: 'Un siège plus agréable à vivre' },
          { v: 'proteger', t: 'Protéger', s: 'Contre l\'usure et les salissures' },
          { v: 'relooker', t: 'Élégance', s: "Donner un nouveau style à l'habitacle" },
          { v: 'sport', t: 'Sport', s: 'Un look plus affirmé' },
          { v: 'saison', t: 'Saison', s: "Fraîcheur l'été, douceur l'hiver" }]
      };
      case 'H1b': return {
        type: 'choix', titre: 'Pour quelle saison ?', aide: '',
        options: [{ v: 'ete', t: "L'été", s: 'Fraîcheur' }, { v: 'hiver', t: "L'hiver", s: 'Douceur' }]
      };
      case 'H5': return {
        type: 'visuel', titre: 'Quelle matière vous attire ?', aide: 'Choix visuel, une photo par matière.',
        options: [{ v: 'simili_cuir', t: 'Simili cuir', k: 'K01' }, { v: 'tissu', t: 'Tissu', k: 'K02' }, { v: 'lin', t: 'Toucher lin', k: 'K03' }, { v: 'indifferent', t: 'Peu importe' }]
      };
      case 'H6': return {
        type: 'visuel', titre: 'Quel style recherchez-vous ?', aide: 'Choix visuel, une photo par style.',
        options: [{ v: 'discret', t: 'Discret', k: 'K04' }, { v: 'elegant', t: 'Élégant', k: 'K05' }, { v: 'sportif', t: 'Sportif', k: 'K06' }, { v: 'indifferent', t: 'Peu importe' }]
      };
      /* --- Organisation --- */
      case 'O1': return {
        type: 'multi', titre: "Qu'est-ce qui vous gêne le plus dans votre habitacle ?",
        aide: 'Plusieurs réponses possibles : nous commencerons par la première que vous choisissez.',
        options: [
          { v: 'rangement', t: 'Des objets qui traînent partout' },
          { v: 'telephone', t: "Mon téléphone n'est pas bien placé" },
          { v: 'proprete', t: 'La saleté et les déchets' }]
      };
      case 'O2': return {
        type: 'choix', titre: 'Où souhaitez-vous ranger vos affaires ?', aide: 'Une seule zone pour commencer.',
        options: [
          { v: 'dos_sieges', t: 'Au dos des sièges avant' }, { v: 'entre_sieges', t: 'Entre les sièges' },
          { v: 'console', t: 'Sur la console centrale' }, { v: 'coffre', t: 'Dans le coffre' }]
      };
      case 'O4': return {
        type: 'choix', titre: 'Qui voyage le plus souvent avec vous ?', aide: 'Cela nous aide à adapter votre sélection.',
        options: [{ v: 'seul', t: 'Souvent seul(e)' }, { v: 'deux', t: 'À deux' }, { v: 'famille', t: 'Famille avec enfants' }]
      };
      case 'P2': return {
        type: 'choix', titre: 'Où souhaitez-vous installer votre téléphone ?', aide: 'Choisissez l\'emplacement où il vous gênera le moins.',
        options: [
          { v: 'aeration', t: "Sur la grille d'aération" }, { v: 'tableau_de_bord', t: 'Sur le tableau de bord' },
          { v: 'pare_brise', t: 'Sur le pare-brise' }, { v: 'console', t: 'Sur la console centrale' }, { v: 'inconnu', t: 'Je ne sais pas' }]
      };
      case 'P3': return {
        type: 'choix', titre: 'Souhaitez-vous le recharger sans fil ?', aide: 'Cela dépend de votre téléphone.',
        options: [{ v: 'oui', t: 'Oui' }, { v: 'non', t: 'Non' }, { v: 'peu_importe', t: 'Peu importe' }]
      };
      case 'N2': return {
        type: 'choix', titre: 'Que souhaitez-vous régler en priorité ?', aide: 'Une seule réponse.',
        options: [
          { v: 'poussiere', t: 'Poussière et miettes' }, { v: 'dechets', t: 'Déchets' },
          { v: 'vitres', t: 'Vitres et tableau de bord' }, { v: 'carrosserie', t: 'La carrosserie (extérieur)' }]
      };
      /* --- Ambiance --- */
      case 'A1': return {
        type: 'choix', titre: 'Souhaitez-vous parfumer ou décorer votre voiture ?', aide: 'Si vous voulez les deux, commencez par ce qui compte le plus.',
        options: [
          { v: 'parfum', t: 'Parfumer' }, { v: 'deco', t: 'Décorer' }, { v: 'les_deux', t: 'Les deux', s: 'Nous commençons par le parfum' }]
      };
      case 'A2': return {
        type: 'visuel', titre: 'Quel format préférez-vous ?', aide: 'Choix visuel, une photo par format.',
        options: [{ v: 'diffuseur', t: 'Diffuseur', k: 'K07' }, { v: 'desodorisant', t: 'Désodorisant à suspendre', k: 'K08' }, { v: 'inconnu', t: 'Je ne sais pas' }]
      };
      case 'A2b': return {
        type: 'visuel', titre: 'Que cherchez-vous ?', aide: 'Choix visuel, une photo par univers.',
        options: [{ v: 'figurines', t: 'Des figurines', k: 'K09' }, { v: 'stickers', t: 'Des stickers et autocollants', k: 'K10' }, { v: 'inconnu', t: 'Je ne sais pas encore' }]
      };
      /* --- Chapitre 3 --- */
      case 't70': return { type: 'transition', chap: 'On y est presque', texte: 'Plus que quelques informations pour afficher votre sélection.', titre: 'On y est presque' };
      case 'S1': {
        var autres = BRANCHES.filter(function (k) { return k !== brancheBase(); });
        var nomSP = { rangement: 'Le rangement', telephone: 'Mon téléphone', proprete: 'La propreté' };
        var opts = sousParcoursEnAttente().map(function (k) { return { v: 'sp_' + k, t: nomSP[k], s: 'Dans votre habitacle' }; })
          .concat(autres.map(function (k) { return { v: k, t: NOM_BRANCHE[k], s: SOUS_TEXTE[k] }; }));
        if (!enChemin('equipe')) opts.push({ v: 'non', t: 'Non merci', excl: true });
        return { type: 'multi', titre: 'Souhaitez-vous aussi améliorer autre chose ?', aide: 'Facultatif. Nous ajouterons des idées à votre sélection.', options: opts };
      }
      case 'S2': return {
        type: 'couleur', titre: 'Quelle est la couleur dominante de votre intérieur ?',
        aide: 'Nous présélectionnerons la variante qui s\'accorde le mieux.', options: COULEURS
      };
      case 'S3': return { type: 'apercu' };
      case 'S4': return { type: 'email' };
      case 'S5': return {
        type: 'choix', titre: 'Souhaitez-vous aussi recevoir nos conseils et nos offres par e-mail ?',
        aide: 'Votre bilan vous est envoyé dans tous les cas. Vous pouvez vous désinscrire à tout moment.',
        options: [{ v: 'oui', t: 'Oui, avec mon offre de bienvenue' }, { v: 'non', t: 'Non, merci' }]
      };
      case 'S6': return { type: 'charge' };
    }
    return { type: 'transition', chap: '', texte: '' };
  }

  function imageDe(id, d) {
    if (d && d.imgId) return d.imgId;
    return IMG[id] || null;
  }

  /* ------------------------------------------------------------------ */
  /* Routage : écran suivant                                             */
  /* ------------------------------------------------------------------ */
  function premier(b) {
    return { confort: 'C1', housses: 'H1', organisation: 'O1', ambiance: 'A1' }[b] || 'pivot';
  }
  /* Saute les écrans déjà répondus par un lien profond. */
  function sauterPresets(id) {
    var garde = 0;
    while (S.preset.indexOf(id) >= 0 && garde++ < 12) id = suivant(id, true);
    return id;
  }
  function apresS1() {
    return (inclus(['confort', 'housses'], branche())) ? 'S2' : fin();
  }
  function fin() {
    return identite() ? 'RESULTAT' : 'S3';
  }
  function debutChapitre3() {
    if (S.sauteS1 || enChemin('equipe') && enChemin('S1')) return (inclus(['confort', 'housses'], branche())) ? 'S2' : fin();
    return 'S1';
  }

  function suivant(id, interne) {
    var a;
    switch (id) {
      case 'accueil': return 't1';
      case 't1': return 'pivot';
      case 'pivot': return A('pivot') === 'inconnu' ? 'orient' : 't2';
      case 'orient': return (A('orient') || []).length === 1 ? 't2' : 'arb';
      case 'arb':
        if (enChemin('O1') && !enChemin('orient')) return sauterPresets(premierSousParcours());
        return 't2';
      case 't2': return interne ? premier(branche()) : sauterPresets(premier(branche()));
      /* Confort */
      case 'C1': return A('C1') === 'partout' ? 'C1b' : 'C2';
      case 'C1b': return 'C2';
      case 'C2': return zone() === 'position' ? 'C4' : 'C3';
      case 'C3': return 'C4';
      case 'C4': return 'C5';
      case 'C5': return 'C6';
      case 'C6':
        if (toutesPossedees()) return 'equipe';
        if (zonesCouvertes().indexOf(zoneInitiale()) >= 0) return 'couvert';
        return c7ou70();
      case 'couvert': return A('couvert') === 'completer' ? 'couvert2' : c7ou70();
      case 'couvert2': return c7ou70();
      case 'equipe': return 'S1';
      case 'C7': return 't70';
      /* Housses */
      case 'H1': return A('H1') === 'saison' ? 'H1b' : 'H5';
      case 'H1b': return 'H5';
      case 'H5': return 'H6';
      case 'H6': return 't70';
      /* Organisation */
      case 'O1': return (A('O1') || []).length > 1 ? 'arb' : premierSousParcours();
      case 'O2': return 'O4';
      case 'O4': return 't70';
      case 'P2': return 'P3';
      case 'P3': return 't70';
      case 'N2': return 't70';
      /* Ambiance */
      case 'A1': return A('A1') === 'deco' ? 'A2b' : 'A2';
      case 'A2': return A('A1') === 'les_deux' ? 'A2b' : 't70';
      case 'A2b': return 't70';
      /* Chapitre 3 */
      case 't70': return debutChapitre3();
      case 'S1':
        if (enChemin('equipe')) return 't2';
        return apresS1();
      case 'S2': return fin();
      case 'S3': return 'S4';
      case 'S4': return 'S5';
      case 'S5': return 'S6';
    }
    return 'accueil';
  }
  function premierSousParcours() {
    var sp = sousParcours();
    return { rangement: 'O2', telephone: 'P2', proprete: 'N2' }[sp] || 'O2';
  }

  function modeRecette() { return !!(window.ScBilanOmnisend && typeof window.ScBilanOmnisend.recette === 'function' && window.ScBilanOmnisend.recette()); }

  /* ------------------------------------------------------------------ */
  /* Rendu                                                               */
  /* ------------------------------------------------------------------ */
  function carte(o, groupe, selection, multi) {
    var sel = multi ? inclus(selection, o.v) : selection === o.v;
    return '<button type="button" class="bq-carte" role="' + (multi ? 'checkbox' : 'radio') + '" aria-checked="' + (sel ? 'true' : 'false') + '"' +
      (multi ? ' data-multi' : '') + ' data-v="' + echapper(o.v) + '"' + (o.excl ? ' data-excl' : '') + '>' +
      '<span class="bq-carte__marque">' + ICONE_COCHE + '</span>' +
      '<span class="bq-carte__txt"><span class="bq-carte__t">' + echapper(o.t) + '</span>' +
      (o.s ? '<span class="bq-carte__s">' + echapper(o.s) + '</span>' : '') + '</span></button>';
  }
  function carteVisuelle(o, selection) {
    var sel = selection === o.v;
    if (!o.k) {
      return '<button type="button" class="bq-vis bq-vis--texte" role="radio" aria-checked="' + (sel ? 'true' : 'false') + '" data-v="' + echapper(o.v) + '"><span class="bq-vis__t">' + echapper(o.t) + '</span></button>';
    }
    var src = IMAGES[o.k];
    return '<button type="button" class="bq-vis" role="radio" aria-checked="' + (sel ? 'true' : 'false') + '" data-v="' + echapper(o.v) + '">' +
      '<span class="bq-vis__img' + (src ? '' : ' bq-sans-image') + '">' +
      (src ? '<img src="' + echapper(src) + '" width="800" height="800" alt="" loading="lazy" decoding="async" data-bq-img>' : '') + '</span>' +
      '<span class="bq-vis__t">' + echapper(o.t) + '</span></button>';
  }

  function titre(d, niveau) {
    return '<h1 class="bq__titre" data-bq-titre>' + echapper(d.titre) + '</h1>' + (d.aide ? '<p class="bq__aide">' + echapper(d.aide) + '</p>' : '');
  }

  function htmlEcran(id, d) {
    var rep = S.ans[id];
    var h = '';
    switch (d.type) {
      case 'accueil':
        h += '<h1 class="bq__titre" data-bq-titre>Votre bilan confort &amp; équipement</h1>' +
          '<p class="bq__texte">Quelques questions pour vous montrer les accessoires vraiment adaptés à votre voiture et à vos trajets.</p>' +
          '<ul class="bq__chapitres"><li><b>01</b> Votre priorité</li><li><b>02</b> Votre situation</li><li><b>03</b> Votre sélection</li></ul>' +
          '<div class="bq__actions"><button type="button" class="bq-btn" data-bq-demarrer>Démarrer le bilan</button></div>' +
          '<p class="bq__mention">Gratuit et sans engagement. Votre sélection est personnalisée à partir de vos réponses.</p>';
        break;
      case 'transition':
        // « Chapitre N · Titre » est le titre de l'écran ; « On y est presque » aussi.
        h += '<h1 class="bq__titre" data-bq-titre>' + echapper(d.titre || d.chap) + '</h1>' +
          '<p class="bq__texte">' + echapper(d.texte) + '</p>' +
          '<div class="bq__actions"><button type="button" class="bq-btn" data-bq-continuer>Continuer</button></div>';
        break;
      case 'info':
        h += titre(d) + '<p class="bq__texte">' + echapper(d.texte) + '</p>' +
          '<div class="bq__actions"><button type="button" class="bq-btn" data-bq-continuer>Continuer</button></div>';
        break;
      case 'choix':
        h += titre(d) + '<div class="bq__cartes" role="radiogroup" aria-label="' + echapper(d.titre) + '">' +
          d.options.map(function (o) { return carte(o, id, rep, false); }).join('') + '</div>';
        break;
      case 'multi': {
        var sel = Array.isArray(rep) ? rep : [];
        h += titre(d) + '<div class="bq__cartes" role="group" aria-label="' + echapper(d.titre) + '">' +
          d.options.map(function (o) { return carte(o, id, sel, true); }).join('') + '</div>' +
          '<div class="bq__actions"><button type="button" class="bq-btn" data-bq-valider ' + (sel.length ? '' : 'disabled') + '>Continuer</button></div>';
        break;
      }
      case 'visuel':
        h += titre(d) + '<div class="bq__visuels" role="radiogroup" aria-label="' + echapper(d.titre) + '">' +
          d.options.map(function (o) { return carteVisuelle(o, rep); }).join('') + '</div>';
        break;
      case 'couleur':
        h += titre(d) + '<div class="bq__couleurs" role="radiogroup" aria-label="' + echapper(d.titre) + '">' +
          d.options.map(function (o) {
            return '<button type="button" class="bq-coul" role="radio" aria-checked="' + (rep === o.v ? 'true' : 'false') + '" data-v="' + echapper(o.v) + '">' +
              '<span class="bq-coul__pastille" style="background:' + o.c + '">' + (o.inconnu ? '?' : '') + '</span>' +
              '<span class="bq-coul__t">' + echapper(o.t) + '</span></button>';
          }).join('') + '</div>';
        break;
      case 'apercu': {
        var n = nombreProduits();
        h += '<h1 class="bq__titre" data-bq-titre>Votre sélection est prête</h1>' +
          '<p class="bq__texte">D\'après vos réponses, nous avons retenu ' + pluriel(n, 'produit compatible', 'produits compatibles') + ' pour ' + echapper(phrase()) + '. Où devons-nous vous envoyer votre bilan ?</p>' +
          '<div class="bq__actions"><button type="button" class="bq-btn" data-bq-continuer>Continuer</button></div>';
        break;
      }
      case 'email':
        h += '<h1 class="bq__titre" data-bq-titre>Quelle est votre adresse e-mail ?</h1>' +
          '<p class="bq__aide">Vous recevrez votre sélection et vos conseils d\'installation. Votre adresse n\'est pas partagée avec d\'autres sociétés.</p>' +
          '<form data-bq-form novalidate>' +
          '<label class="bq__champ" for="bq-email">Votre e-mail</label>' +
          '<input class="bq__input" id="bq-email" name="email" type="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" value="' + echapper(S.ans.S4 || '') + '" aria-describedby="bq-email-err">' +
          '<p class="bq__erreur" id="bq-email-err" role="alert" data-bq-erreur></p>' +
          '<div class="bq__actions"><button type="submit" class="bq-btn" data-bq-envoyer disabled>Continuer</button></div>' +
          '<p class="bq__legal"><a href="' + echapper(DATA.url_confidentialite || '/pages/politique-de-confidentialite') + '" target="_blank" rel="noopener">Politique de confidentialité</a></p>' +
          (modeRecette() ? '<p class="bq__mention"><strong>Mode recette</strong> (aperçu du thème) : votre adresse n\'est envoyée nulle part.</p>' : '') +
          '</form>';
        break;
      case 'charge':
        h += '<div class="bq__charge"><div class="bq__spin" aria-hidden="true"></div><p class="bq__texte" role="status">Un instant, nous préparons votre sélection…</p></div>';
        break;
    }
    // « Changer de sujet » : lien discret sur les deux premiers écrans d'un lien profond.
    if (S.profond && !S.sauteS1 && S.pile.length <= 1 && !/^(accueil|S\d)$/.test(id) && id !== 't70') {
      h += '<p class="bq__mention"><button type="button" class="bq__discret" data-bq-changer>Changer de sujet</button></p>';
    }
    return h;
  }

  var SANS_PRECEDENT = { accueil: 1, S6: 1 };

  function rendre() {
    var id = S.cur;
    var d = def(id);
    ecran.innerHTML = htmlEcran(id, d);

    // visuel
    var imgId = imageDe(id, d);
    var src = imgId ? IMAGES[imgId] : null;
    visuel.className = 'bq__visuel' + (src ? '' : ' bq-sans-image');
    visuel.innerHTML = src ? '<img src="' + echapper(src) + '" width="960" height="1536" alt="" ' + (id === 'accueil' ? 'fetchpriority="high" ' : '') + 'decoding="async" data-bq-img>' : '';
    // Le panneau est toujours à l'écran : jamais en chargement différé (seules les cartes K le sont).
    precharger(id);

    // barre du haut
    var p = pourcent();
    barre.querySelector('span').style.width = p + '%';
    barre.setAttribute('aria-valuenow', String(p));
    pctTexte.innerHTML = p + '&nbsp;%';
    // « Retour au site » sur l'accueil (ou sans historique), « Précédent » ensuite.
    var peutRevenir = S.pile.length > 0 && !SANS_PRECEDENT[id];
    btnPrecedent.hidden = !peutRevenir;
    lienRetour.hidden = peutRevenir;
    if (id === 'S6') { btnPrecedent.hidden = true; lienRetour.hidden = true; }

    // focus sur le titre : lecteur d'écran + clavier
    var t = ecran.querySelector('[data-bq-titre]');
    if (t) { t.setAttribute('tabindex', '-1'); try { t.focus({ preventScroll: true }); } catch (e) { } }
    contenu.scrollTop = 0;

    // l'e-mail : prêt à saisir
    if (id === 'S4') {
      var champ = ecran.querySelector('#bq-email');
      validerEmail(champ, false);
    }
  }

  /* Précharge l'image de l'écran suivant probable (sans bloquer l'affichage). */
  function precharger(id) {
    try {
      var n = suivant(id, true), i = IMG[n];
      if (i && IMAGES[i]) { var im = new Image(); im.src = IMAGES[i]; }
    } catch (e) { }
  }

  /* Une image absente laisse l'aplat d'accent : jamais d'image cassée. */
  document.addEventListener('error', function (e) {
    var cible = e.target;
    if (!cible || !cible.matches || !cible.matches('[data-bq-img]')) return;
    var parent = cible.parentNode;
    if (parent) parent.classList.add('bq-sans-image');
  }, true);

  /* ------------------------------------------------------------------ */
  /* Navigation                                                          */
  /* ------------------------------------------------------------------ */
  function aller(id, sansHistorique) {
    if (id === 'RESULTAT') { terminer(); return; }
    if (S.cur && S.cur !== id) S.pile.push(S.cur);
    S.cur = id;
    sauver();
    rendre();
    suivre('quiz_step_view', { step_id: id, step_index: S.pile.length + 1, branch: branche() || '' });
    if (!sansHistorique) { try { history.pushState({ bq: 1 }, '', location.pathname + location.search + '#' + id); } catch (e) { } }
    // S6 : chargement, puis envoi et redirection.
    if (id === 'S6') setTimeout(terminer, 60);
  }
  function retour() {
    if (!S.pile.length) return;
    S.cur = S.pile.pop();
    sauver();
    rendre();
  }
  function avancer() {
    var proch = suivant(S.cur);
    if (proch === 'S1') preselectionS1();
    aller(proch);
  }

  window.addEventListener('popstate', function () {
    if (S.pile.length) retour();
  });

  /* ------------------------------------------------------------------ */
  /* Réponses                                                            */
  /* ------------------------------------------------------------------ */
  function choisir(id, valeur) {
    S.ans[id] = valeur;
    var libelle = Array.isArray(valeur) ? valeur.join(',') : valeur;
    suivre('quiz_answer', { question_id: id, answer: libelle });
    if (id === 'S5') suivre('quiz_optin', { choice: valeur });
  }

  function brancheDeterminee() {
    var b = branche();
    if (b) suivre('quiz_branch_selected', { branch: b, via: viaBranche() });
  }
  function viaBranche() {
    if (S.force && S.sauteS1) return 'exploration';
    if (S.force) return 'lien profond';
    if (enChemin('equipe')) return 'arbitrage';
    if (enChemin('arb')) return 'arbitrage';
    if (enChemin('orient')) return 'orientation';
    return 'pivot';
  }

  ecran.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    if (cible.closest('[data-bq-demarrer]')) {
      suivre('quiz_start', { source: S.src, besoin_prefill: S.profond ? (parametreUrl('besoin') || '') : '', run_index: S.run, returning: !!identite() });
      avancer(); return;
    }
    if (cible.closest('[data-bq-continuer]')) { avancer(); return; }
    if (cible.closest('[data-bq-changer]')) { changerDeSujet(); return; }

    var bouton = cible.closest('.bq-carte, .bq-vis, .bq-coul');
    if (bouton) {
      var d = def(S.cur), v = bouton.getAttribute('data-v');
      if (d.type === 'multi') { basculer(bouton, d, v); return; }
      // réponse unique : état « sélectionné » puis on avance
      ecran.querySelectorAll('[role="radio"]').forEach(function (b) { b.setAttribute('aria-checked', b === bouton ? 'true' : 'false'); });
      choisir(S.cur, v);
      setTimeout(function () {
        if (S.cur === 'pivot' || S.cur === 'arb' || S.cur === 'orient' || S.cur === 'S1') brancheDeterminee();
        avancer();
      }, 170);
      return;
    }
    if (cible.closest('[data-bq-valider]')) {
      var dm = def(S.cur), sel = (S.ans[S.cur] || []).slice();
      if (!sel.length) return;
      choisir(S.cur, sel);
      if (S.cur === 'orient' || S.cur === 'S1') brancheDeterminee();
      avancer();
    }
  });

  /* Choix multiple : l'ordre de sélection est conservé (« la première que vous choisissez »). */
  function basculer(bouton, d, v) {
    var sel = Array.isArray(S.ans[S.cur]) ? S.ans[S.cur].slice() : [];
    var exclusive = bouton.hasAttribute('data-excl');
    if (exclusive) { sel = inclus(sel, v) ? [] : [v]; }
    else {
      d.options.forEach(function (o) { if (o.excl) sel = sel.filter(function (x) { return x !== o.v; }); });
      sel = inclus(sel, v) ? sel.filter(function (x) { return x !== v; }) : sel.concat([v]);
    }
    S.ans[S.cur] = sel;
    ecran.querySelectorAll('[role="checkbox"]').forEach(function (b) {
      b.setAttribute('aria-checked', inclus(sel, b.getAttribute('data-v')) ? 'true' : 'false');
    });
    var valider = ecran.querySelector('[data-bq-valider]');
    if (valider) valider.disabled = !sel.length;
    sauver();
  }

  /* Présélection de S1 : les autres sujets cochés plus tôt. */
  function preselectionS1() {
    if (S.ans.S1 === undefined || !enChemin('S1')) {
      var att = enAttente();
      if (att.length) S.ans.S1 = att.slice();
    }
  }
  btnPrecedent.addEventListener('click', function () { retour(); });

  function changerDeSujet() {
    S.ans = {}; S.pile = []; S.preset = []; S.force = null; S.profond = false; S.sauteS1 = false;
    S.cur = 'pivot'; sauver(); rendre();
    try { history.replaceState({ bq: 1 }, '', location.pathname + '#pivot'); } catch (e) { }
  }

  /* ------------------------------------------------------------------ */
  /* E-mail                                                              */
  /* ------------------------------------------------------------------ */
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function validerEmail(champ, afficherErreur) {
    var bouton = ecran.querySelector('[data-bq-envoyer]');
    var zoneErreur = ecran.querySelector('[data-bq-erreur]');
    var ok = RE_EMAIL.test((champ.value || '').trim());
    if (bouton) bouton.disabled = !ok;
    if (afficherErreur && champ.value && !ok) {
      zoneErreur.textContent = 'Veuillez saisir une adresse e-mail valide.';
      champ.setAttribute('aria-invalid', 'true');
    } else {
      zoneErreur.textContent = '';
      champ.removeAttribute('aria-invalid');
    }
    return ok;
  }
  ecran.addEventListener('input', function (e) {
    if (e.target && e.target.id === 'bq-email') validerEmail(e.target, false);
  });
  ecran.addEventListener('focusout', function (e) {
    if (e.target && e.target.id === 'bq-email') validerEmail(e.target, true);
  });
  ecran.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('[data-bq-form]') : null;
    if (!form) return;
    e.preventDefault();
    var champ = form.querySelector('#bq-email');
    if (!validerEmail(champ, true)) { champ.focus(); return; }
    S.ans.S4 = champ.value.trim();
    suivre('quiz_email_submitted', {});
    avancer();
  });

  /* ------------------------------------------------------------------ */
  /* Fin du parcours : envoi, puis page de résultat                      */
  /* ------------------------------------------------------------------ */
  function urlResultat() {
    var p = [];
    function ajouter(cle, val) { if (val !== undefined && val !== null && val !== '') p.push(cle + '=' + encodeURIComponent(val)); }
    var s = sortie(), b = branche();
    ajouter('s', s);
    ajouter('l', listes().join(','));
    if (b === 'confort') {
      ajouter('z', zone());
      if (zone() !== 'position') ajouter('so', A('C3'));
      ajouter('pr', A('C4'));
      ajouter('ck', A('C5'));
      ajouter('tr', A('C2'));
    }
    if (b === 'housses') {
      if (A('H5') !== 'indifferent') ajouter('ma', A('H5'));
      if (A('H6') !== 'indifferent') ajouter('st', A('H6'));
    }
    if (b === 'organisation') {
      if (s === 'organisation_rangement') { ajouter('x', A('O2')); ajouter('fa', A('O4')); }
      if (s === 'organisation_proprete') ajouter('x', A('N2'));
    }
    ajouter('co', A('S2'));
    ajouter('b', b);
    ajouter('sec', secondaires().join(','));
    ajouter('src', S.src);
    ajouter('r', S.run);
    return (DATA.url_resultat || '/pages/votre-selection') + '?' + p.join('&');
  }

  /* Propriétés envoyées à Omnisend (section 11.2), en minuscules sans accent. */
  function proprietes() {
    var b = branche(), s = sortie(), o = {};
    function pose(cle, val) { if (val !== undefined && val !== null && val !== '' && !(Array.isArray(val) && !val.length)) o[cle] = val; }
    pose('quiz_besoin', b);
    pose('quiz_sortie', s);
    if (b === 'confort') {
      var zs = [zone()]; if (A('C7') && A('C7') !== 'non') zs.push(A('C7'));
      pose('quiz_zone', zs.join(','));
      pose('quiz_trajets', A('C2')); pose('quiz_soutien', A('C3')); pose('quiz_priorite', A('C4'));
      pose('quiz_siege', A('C5')); pose('quiz_equipement', (A('C6') || []).join(','));
    }
    if (b === 'housses') {
      var h1 = A('H1'); pose('quiz_objectif_housses', h1 === 'saison' ? (A('H1b') === 'hiver' ? 'saison_hiver' : 'saison_ete') : h1);
      pose('quiz_matiere', A('H5')); pose('quiz_style_housse', A('H6'));
    }
    if (b === 'organisation') {
      pose('quiz_sous_parcours', sousParcours()); pose('quiz_emplacement', A('O2')); pose('quiz_famille', A('O4'));
      pose('quiz_telephone_emplacement', A('P2')); pose('quiz_telephone_sans_fil', A('P3')); pose('quiz_proprete_groupe', A('N2'));
    }
    if (b === 'ambiance') {
      pose('quiz_ambiance', A('A1') === 'les_deux' ? 'les_deux' : A('A1'));
      pose('quiz_format', [A('A2'), A('A2b')].filter(Boolean).join(','));
    }
    var branchesSec = secondaires().filter(function (x) { return x.indexOf('sp_') !== 0; });
    var sousSec = secondaires().filter(function (x) { return x.indexOf('sp_') === 0; }).map(function (x) { return x.slice(3); });
    pose('quiz_besoin_secondaire', branchesSec.length ? branchesSec.join(',') : 'aucun');
    pose('quiz_sous_parcours_suivants', sousSec.join(','));
    pose('quiz_couleur', A('S2'));
    pose('quiz_source', S.src);
    return o;
  }

  var terminaison = false;
  function terminer() {
    if (terminaison) return;
    terminaison = true;
    var id = identite();
    var url = urlResultat();
    var n = nombreProduits();

    // identité mémorisée pour les prochains bilans de cet appareil
    var st = lire(CLE_ID, localStorage) || {};
    var nb = (st.nb || 0) + 1;
    var email = S.ans.S4 ? S.ans.S4 : (id && id.email) || null;
    var optin = S.ans.S5 || (id && id.optin) || null;
    if (email) {
      ecrire(CLE_ID, { email: email, optin: optin, premier: st.premier || aujourdhui(), nb: nb, date: aujourdhui() }, localStorage);
    } else {
      ecrire(CLE_ID, { optin: optin, premier: st.premier || aujourdhui(), nb: nb, date: aujourdhui() }, localStorage);
    }
    var premierBilan = nb === 1;
    // Page de résultat : « Votre bilan a été envoyé à … » au premier bilan, si l'adresse vient d'être saisie.
    ecrire('sc_bilan_envoye', { email: S.ans.S4 || null, premier: premierBilan && !!S.ans.S4 });
    var charge = {
      email: email, optin: optin, nouveau: !!S.ans.S5, premier: premierBilan, via: id ? id.via : 'saisie',
      proprietes: proprietes(), url: url, produits: n, run: S.run,
      sortie: sortie(), phrase: phrase(), date: aujourdhui()
    };
    suivre('quiz_complete', { sortie: sortie(), products_count: n, run_index: S.run, returning: !!id });
    if (id) suivre('quiz_identity_known', { via: id.via });

    // L'envoi est tenté sans jamais bloquer : la redirection part au plus tard après ~2,6 s.
    var parti = false;
    function partir() {
      if (parti) return; parti = true;
      effacer(CLE_SESSION);
      window.location.href = url;
    }
    setTimeout(partir, 2600);
    var envoi = (window.ScBilanOmnisend && typeof window.ScBilanOmnisend.envoyer === 'function')
      ? window.ScBilanOmnisend.envoyer(charge) : Promise.resolve();
    Promise.resolve(envoi).then(partir, function () { mettreEnFile(charge); partir(); });
  }
  function mettreEnFile(charge) {
    var f = lire(CLE_FILE, localStorage) || [];
    f.push(charge); ecrire(CLE_FILE, f.slice(-5), localStorage);
  }

  /* ------------------------------------------------------------------ */
  /* Démarrage : reprise, liens profonds                                 */
  /* ------------------------------------------------------------------ */
  var BESOINS = {
    dos: { b: 'confort', pre: { C1: 'dos' } }, nuque: { b: 'confort', pre: { C1: 'nuque' } },
    assise: { b: 'confort', pre: { C1: 'assise' } }, position: { b: 'confort', pre: { C1: 'position' } },
    'longs-trajets': { b: 'confort', pre: { C1: 'partout' } },
    housses: { b: 'housses', pre: {} }, organisation: { b: 'organisation', pre: {} },
    rangement: { b: 'organisation', pre: { O1: ['rangement'] } }, telephone: { b: 'organisation', pre: { O1: ['telephone'] } },
    proprete: { b: 'organisation', pre: { O1: ['proprete'] } },
    ambiance: { b: 'ambiance', pre: {} }, parfum: { b: 'ambiance', pre: { A1: 'parfum' } }, deco: { b: 'ambiance', pre: { A1: 'deco' } }
  };

  function demarrer() {
    var id = identite();
    var st = lire(CLE_ID, localStorage) || {};
    S.run = (st.nb || 0) + 1;

    var source = (parametreUrl('source') || '').toLowerCase().replace(/[^a-z0-9\-_.]/g, '').slice(0, 60);
    var besoin = parametreUrl('besoin');
    var explorer = parametreUrl('explore');
    var refaire = parametreUrl('refaire');

    // Exploration depuis la page de résultat : on garde l'identité, on saute S1 et l'e-mail.
    if (explorer && inclus(BRANCHES, explorer)) {
      S.ans = {}; S.pile = []; S.preset = []; S.force = explorer; S.sauteS1 = true; S.profond = true; S.src = source || 'exploration';
      var sous = parametreUrl('sous');
      if (explorer === 'organisation' && inclus(SOUS, sous)) { S.preset = ['O1']; S.ans.O1 = [sous]; }
      S.cur = 't2';
      suivre('quiz_start', { source: S.src, besoin_prefill: explorer + (S.ans.O1 ? ':' + S.ans.O1[0] : ''), run_index: S.run, returning: !!id });
      suivre('quiz_branch_selected', { branch: explorer, via: 'exploration' });
      sauver(); rendre();
      try { history.replaceState({ bq: 1 }, '', location.pathname + '#t2'); } catch (e) { }
      return;
    }
    // Lien profond : l'accueil et le chapitre 1 sont sautés.
    if (besoin && BESOINS[besoin]) {
      var cfg = BESOINS[besoin];
      S.ans = {}; S.pile = []; S.preset = Object.keys(cfg.pre); S.force = cfg.b; S.sauteS1 = false; S.profond = true; S.src = source;
      Object.keys(cfg.pre).forEach(function (k) { S.ans[k] = cfg.pre[k]; });
      S.cur = 't2';
      suivre('quiz_start', { source: S.src, besoin_prefill: besoin, run_index: S.run, returning: !!id });
      suivre('quiz_branch_selected', { branch: cfg.b, via: 'lien profond' });
      sauver(); rendre();
      try { history.replaceState({ bq: 1 }, '', location.pathname + location.search + '#t2'); } catch (e) { }
      return;
    }
    // « Refaire le bilan » : réponses effacées, identité conservée.
    if (refaire) { effacer(CLE_SESSION); }

    // Reprise : recharger la page reprend le parcours.
    var sav = refaire ? null : lire(CLE_SESSION);
    if (sav && sav.cur) {
      S.ans = sav.ans || {}; S.pile = sav.pile || []; S.cur = sav.cur; S.preset = sav.preset || [];
      S.force = sav.force || null; S.sauteS1 = !!sav.sauteS1; S.src = sav.src || source; S.profond = !!sav.profond; S.run = sav.run || S.run;
      if (S.cur === 'S6') S.cur = 'S5';
      sauver(); rendre();
      return;
    }
    S.src = source;
    S.cur = 'accueil';
    sauver(); rendre();
  }

  /* Page de résultat ou autre onglet : l'envoi en attente est retenté ailleurs
     (assets/bilan-selection.js). Ici on se contente d'abandon. */
  window.addEventListener('pagehide', function () {
    if (S.cur !== 'accueil' && S.cur !== 'S6' && !terminaison) suivre('quiz_abandon', { step_id: S.cur, branch: branche() || '' });
  });

  /* Lecture seule : sert aux tests de recette, ne change aucun comportement. */
  window.ScBilan = {
    etat: function () { return S; },
    oublierIdentite: oublierIdentite,
    termine: function () { return terminaison; },
    apercu: function () {
      return { sortie: sortie(), listes: listes(), n: nombreProduits(), url: urlResultat(), phrase: phrase(), proprietes: proprietes(), branche: branche() };
    }
  };

  demarrer();
})();
